
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Title from "./title.vue";
import SubTitle from "./title-sub.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private index: any;
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  @Prop()
  private showAudio: any; // 是否支持语音播放
  @Prop()
  private ifPlay: any; // 是否播放语音
  @Prop()
  private playIndex: any; // 语音播放索引
  @Watch("playIndex")
  private playIndexChange(val: any) {
    this.$forceUpdate();
  }

  private get c() {
    if (!this.content.value) {
      this.content.value = {};
    }
    return JSON.parse(JSON.stringify(this.content));
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private valueChange() {
    if (this.source === "dialog") {
      this.$emit("updateDialog", this.c);
    } else {
      this.$emit("update", this.c);
      if (this.showAudio) {
        this.$emit("changeAudio", this.c);
      }
    }
  }
  private isChecked(item: any) {
    if (this.c.name === item.name) {
      return true;
    } else {
      return false;
    }
  }
  private radioScoreClick(option: any) {
    if (this.isDisabled) {
      return;
    }
    if (
      this.c.value &&
      this.c.value.name &&
      this.c.value.name === option.name
    ) {
      this.c.value = {};
    } else {
      this.c.value = option;
    }
    this.valueChange();
  }
  get isDisabled() {
    const result =
      !this.ifCompose &&
      this.source !== "dialog" &&
      !(this.showAudio && this.ifPlay && this.playIndex == this.index);
    return result;
  }
}
